import { z } from 'zod';
import { dataOraSchema, idSchema, paginationQuerySchema } from '../common';
import { TipoNotifica } from './enums';

/** Una notifica come la vede la SPA (canale in-app). */
export const notificaSchema = z.object({
  id: idSchema,
  tipo: TipoNotifica,
  titolo: z.string(),
  corpo: z.string(),
  /** Payload libero: tipicamente `{ link }` verso progetto/task/fase. */
  dati: z.record(z.string(), z.unknown()),
  lettaIl: dataOraSchema.nullable(),
  creatoIl: dataOraSchema,
});
export type NotificaVista = z.infer<typeof notificaSchema>;

/** Query lista notifiche: contratto di Fase 1 + filtro non-lette. */
export const notificheQuerySchema = paginationQuerySchema.extend({
  soloNonLette: z.coerce.boolean().default(false),
});
export type NotificheQuery = z.infer<typeof notificheQuerySchema>;

/** Conteggio per il badge della campana. */
export const conteggioNonLetteSchema = z.object({ nonLette: z.number().int().min(0) });
export type ConteggioNonLette = z.infer<typeof conteggioNonLetteSchema>;

/** Preferenza di un utente per un tipo: canali indipendenti (no = entrambi off). */
export const preferenzaNotificaSchema = z.object({
  tipo: TipoNotifica,
  inApp: z.boolean(),
  email: z.boolean(),
});
export type PreferenzaNotifica = z.infer<typeof preferenzaNotificaSchema>;

/** Salvataggio preferenze: l'intero set (una riga per tipo). */
export const preferenzeUpdateSchema = z.object({
  preferenze: z.array(preferenzaNotificaSchema),
});
export type PreferenzeUpdate = z.infer<typeof preferenzeUpdateSchema>;

/**
 * Orari proposti per il riepilogo del mattino: ogni mezz'ora dalle 6:00 alle
 * 11:30. Dopo mezzogiorno un riepilogo «del mattino» non serve più.
 */
export const ORARI_RIEPILOGO = [
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
] as const;

/** Preferenze del riepilogo del mattino, per utente. */
export const preferenzaRiepilogoSchema = z.object({
  attivo: z.boolean(),
  orario: z.enum(ORARI_RIEPILOGO),
  /** Solo dal lunedì al venerdì: il lunedì raccoglie anche il fine settimana. */
  soloFeriali: z.boolean(),
});
export type PreferenzaRiepilogo = z.infer<typeof preferenzaRiepilogoSchema>;

/** Valori finché l'utente non li cambia: acceso, alle 9, nei giorni lavorativi. */
export const RIEPILOGO_PREDEFINITO: PreferenzaRiepilogo = {
  attivo: true,
  orario: '09:00',
  soloFeriali: true,
};
